// extracted by mini-css-extract-plugin
export var contact_form = "dispensaryalert-module--contact_form--d7c1b";
export var contact_form_container = "dispensaryalert-module--contact_form_container--62351";
export var contact_form_container_btn = "dispensaryalert-module--contact_form_container_btn--ff396";
export var contact_form_container_name = "dispensaryalert-module--contact_form_container_name--cf2cc";
export var error = "dispensaryalert-module--error--23a1d";
export var error_svg = "dispensaryalert-module--error_svg--3bef4";
export var input_error = "dispensaryalert-module--input_error--44dc1";
export var row = "dispensaryalert-module--row--d5d21";